import { Button, Dropdown } from 'antd';
import { MenuProps } from 'antd';
import { FC } from 'react';
import { useTranslation } from 'react-i18next';
import { MenuOutlined } from '@ant-design/icons';

import { Feature } from '../../../shared/models/features';
import { Tenant } from '../../../shared/models/tenant';
import { translationNamespace } from '../../constants/translation-resources';
import { ActionsProps } from '../tenants-table';

type Props = ActionsProps & {
  onRemove?: (tenant: Tenant) => void;
};

export const TenantSubtenantActions: FC<Props> = ({ tenant, onRemove }) => {
  const { t } = useTranslation(translationNamespace);

  const items: MenuProps['items'] = [
    {
      key: 'remove',
      onClick: () => onRemove(tenant),
      label: t('tenants.single.unassign'),
    },
  ];

  return (
    <Dropdown menu={{ items }} trigger={['click']}>
      <Button type="link" icon={<MenuOutlined />}>
        {t(`${Feature.SHARED}:actions`)}
      </Button>
    </Dropdown>
  );
};
